import { Asset } from "rujira.js";

const runeBase: Asset = {
  type: "NATIVE",
  chain: "THOR",
  asset: "THOR.RUNE",
  metadata: {
    decimals: 8,
    symbol: "RUNE",
  },
  variants: null,
};

export const RUNE: Asset = {
  ...runeBase,
  variants: {
    layer1: runeBase,
    native: { denom: "rune" },
  },
};
